import React, { Component } from 'react'
import { connect } from 'react-redux'
import { AbstractAttendanceComponent, mapStateToProps } from './abstract'
import { Sidebar } from '~/components/sidebar'
import { Header } from '~/components/header'
import { Table } from '~/components/table'
import * as route from '~/helper/constant/route'
import * as SVG from '~/assets/svg'
import { withTranslation } from 'react-i18next'
import * as AccessModule from '~/helper/constant/modules'
import * as UserType from '~/helper/constant/user_type'

class AttendanceComponent extends AbstractAttendanceComponent {
    constructor(props) {
        super(props)
        this.state = {
            ...this.state,
        }
    }

    render() {
        const { t, school } = this.props
        const { access } = this.state
        const role = school != null && school.role != null ? school.role.access : null
        return (
            <div className="main-page">
                <Sidebar id="attendance" />
                <div className="main-content">
                    <Header />
                    <div className="main-head-option">
                        <ul className="list-inline breadcrum clearfix">
                            <li>
                                <a href={route.admin.attendance.menu}>{t('attendance:attendance')}</a>
                            </li>
                        </ul>
                        <div className="row clearfix">
                            <div className="col-md-5 float-left">
                                <h5 className="main-title heading5">{t('attendance:attendance')}:</h5>
                            </div>
                        </div>
                    </div>
                    <div className="folder-page">
                        <div className="row clearfix">
                            {this.props.school.user_type != UserType.Teacher && AccessModule.checkSubAccess([AccessModule.STUDENT_ATTENDANCE], role) && access.includes(AccessModule.Module_Student_Management) && (
                                <div className="float-left course-your">
                                    <div className="folder-list clearfix" onClick={() => (window.location = route.admin.attendance.student.menu)}>
                                        <a href={route.admin.attendance.student.menu} className="folder-img">
                                            {SVG.student()}
                                        </a>
                                        <a href={route.admin.attendance.student.menu} className="folder-name">
                                            {t('attendance:student')}
                                            <span>{t('attendance:student_msg')}</span>
                                        </a>
                                    </div>
                                </div>
                            )}
                            {this.props.school.user_type != UserType.Teacher && AccessModule.checkSubAccess([AccessModule.EMPLOYEE_ATTENDANCE], role) && access.includes(AccessModule.Module_Employee_Management) && (
                                <div className="float-left course-your">
                                    <div className="folder-list clearfix" onClick={() => (window.location = route.admin.attendance.employee.menu)}>
                                        <a href={route.admin.attendance.employee.menu} className="folder-img">
                                            {SVG.employee()}
                                        </a>
                                        <a href={route.admin.attendance.employee.menu} className="folder-name">
                                            {t('attendance:employee')}
                                            <span>{t('attendance:employee_msg')}</span>
                                        </a>
                                    </div>
                                </div>
                            )}
                            {this.props.school.user_type == UserType.Teacher && AccessModule.checkSubAccess([AccessModule.STUDENT_ATTENDANCE], role) && access.includes(AccessModule.Module_Student_Management) && (
                                <div className="float-left course-your">
                                    <div className="folder-list clearfix" onClick={() => (window.location = route.teacher.attendance.filter)}>
                                        <a href={route.teacher.attendance.filter} className="folder-img">
                                            {SVG.student()}
                                        </a>
                                        <a href={route.teacher.attendance.filter} className="folder-name">
                                            {t('attendance:student')}
                                            <span>{t('attendance:student_msg')}</span>
                                        </a>
                                    </div>
                                </div>
                            )}
                            {(AccessModule.checkSubAccess([AccessModule.STUDENT_ATTENDANCE], role) || AccessModule.checkSubAccess([AccessModule.EMPLOYEE_ATTENDANCE], role)) && access.includes(AccessModule.Module_Employee_Management) && (
                                <div className="float-left course-your">
                                    <div className="folder-list clearfix" onClick={() => (window.location = route.report.attendance)}>
                                        <a href={route.report.attendance} className="folder-img">
                                            {SVG.discountIcon()}
                                        </a>
                                        <a href={route.report.attendance} className="folder-name">
                                            {t('attendance:attendanceReport')}
                                            <span>{t('attendance:generateReport')}</span>
                                        </a>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

const Attendance = withTranslation()(connect(mapStateToProps)(AttendanceComponent))

export { Attendance }
